import DataTableAction from '@/components/DataTable/DataTableAction'
import DataTableActionField from '@/components/DataTable/DataTableActionField'
import CreativeImportModule from '@/models/CreativeImportModule'
import SystemtModule from '@/store/SystemModule'
import { getModule } from 'vuex-module-decorators'
import router from '@/Routes'

export default [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    show: true,
    type: 'checkbox',
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'id',
    label: 'ID',
    sortable: false,
    filter: false,
    show: false,
  },
  {
    key: 'advertiser_id',
    label: 'Advertiser',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'code',
    label: 'Code',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'connection',
    label: 'Connection',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'imported_at',
    label: 'Imported At',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'last_tried_at',
    label: 'Last Tried At',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'creative_id',
    label: 'Creative',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  // new DataTableActionField([
  //   new DataTableAction(
  //     'Edit',
  //     'edit',
  //     'pencil',
  //     () => {
  //       const { user } = getModule(SystemtModule) // Check if user has access
  //       return (user && user.can('creative', 'edit')) as boolean
  //     },
  //     (item: CreativeImportModule) => {
  //       router.push({
  //         name: 'creative-import-edit',
  //         params: { id: item.id },
  //       })
  //     },
  //   ),
  // ]),
]
